import React, { SFC } from 'react';
import { ISubscription } from 'interfaces/IProductData';
import Translate from 'components/Translate';
import { CurrencyFormat } from 'components/CurrencyFormat';
import { paymentService } from 'services/PaymentService';

interface IPriceProps {
  subscription: ISubscription;
}

// tslint:disable-next-line:variable-name
export const SubscriptionWithTax: SFC<IPriceProps> = (props) => {
  const { subscription } = props;

  return (
    <div className='chk-subscription'>
      <div className='chk-subscription__text'><Translate term='Adesão de' /></div>
      <div className='chk-subscription__value theme-label'>
        <CurrencyFormat value={subscription.tax} />
      </div>
      <div className='chk-subscription__frequency'>
        + <CurrencyFormat value={subscription.price} />&nbsp;
        <Translate
          term={`a cada {frequency} ${paymentService.getNormalizedFrequencyType(subscription.frequencyType, subscription.frequency)}`}
          properties={
            {
              tax: <CurrencyFormat value={subscription.tax} />,
              frequency: subscription.frequency
            }
          }
        />
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/Cart/Price/Subscription/SubscriptionWithTax/index.tsx